module.exports = __webpack_public_path__ + "static/media/vip.f547f9f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip.png
// module id = 1154
// module chunks = 2